<template>
<div class="DeviceListsGas">
  <div class="devcieContainer" :style="styleObject" v-if="JSON.stringify(tabData) == '{}'">
    <!-- <h4>设备列表</h4> -->
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="container">
      <div class="query">
        <div class="queryCons">
          <el-input class="common" placeholder="设备名称/设备类型/IMEI" autocomplete="off" v-model="searchText" style="width:200px;"></el-input>
          <el-select class="common" v-model="keyWords.isInstall" placeholder="是否安装" clearable>
            <el-option label="已安装" :value="1"></el-option>
            <el-option label="未安装" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isRegist" placeholder="是否注册" clearable>
            <el-option label="已注册" :value="1"></el-option>
            <el-option label="未注册" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isOnline" placeholder="是否在线" clearable>
            <el-option label="在线" :value="true"></el-option>
            <el-option label="离线" :value="false"></el-option>
          </el-select>
          <!-- <el-select class="common" v-model="keyWords.typeId" placeholder="设备类型" clearable>
            <el-option v-for="(item,i) in deviceTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <el-select class="common" v-model="keyWords.isAlarm" placeholder="是否报警" clearable>
            <el-option label="报警" :value="true"></el-option>
            <el-option label="未报警" :value="false"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <el-button
            class="common"
            type="primary"
            size="medium"
            @click="serachData"
            icon="el-icon-search">搜索</el-button>
          <el-button class="delSome" type="primary" size="medium" @click="changeRightCons" icon="el-icon-s-data">实时统计</el-button>
        </div>
      </div>
      <div class="listsContainer" :style="styleObjectCons">
        <!-- :class="changeStatus?'':'active'" -->
        <div class="listsLeft">
          <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="tableLoading">
            <ul class="clearfix device-cardList">
              <li v-for="(item,index) in dataList" :key="index" :class="['device-card', item.isOnline == '离线' ?'outItem':'', item.deviceRemoval == false ? 'noOpen' : '']">
                <h6>
                  <span class="title overText">{{item.name}}</span>
                  <div class="title-right">
                    <!-- 电量 -->
                    <span>{{item.currentPower}}%</span>
                    <span class="electric">
                      <i :class="item.currentPower <= 20 ? 'red':''" :style="{width: item.currentPower + '%'}"></i>
                      <img v-if="item.isOnline == '离线' || item.currentPower == false" src="../../assets/img/devicetype/electric-gray.png" alt="" />
                      <img v-else-if="item.currentPower <= 20" src="../../assets/img/devicetype/electric-red.png" alt="" />
                      <img v-else src="../../assets/img/devicetype/electric.png" alt="" />
                    </span>
                    <!-- 详情按钮 -->
                    <span class="set" @click="clickEven(item)">
                      <i class="el-icon-edit-outline"></i>
                    </span>
                    <!-- 设置按钮 -->
                    <span class="set" @click="handleClickSet(item)">
                      <i class="el-icon-s-tools"></i>
                    </span>
                  </div>
                </h6>
                <div class="chart-item">
                  <div class="chart">
                    <Echarts :ref="`chart${index}`" :chartId="`chart${index}`" :chartOption="chartOption"></Echarts>
                  </div>

                  <div class="device-params">
                    <div>
                      <p class="params-t">IMEI</p>
                      <p class='overText'>{{item.imei || '--'}}</p>
                    </div>
                    <div>
                      <p class="params-t">温度状态</p>
                      <p class='overText'>{{ (item.temperatureAlarm == 0 ? '低温报警' : item.temperatureAlarm == 1 ? '高温报警' : item.temperatureAlarm == 2 ? '正常' : item.temperatureAlarm) || '--' }}</p>
                    </div>
                    <div>
                      <p class="params-t">湿度状态</p>
                      <p class='overText'>{{ (item.humidityAlarm == 0 ? '低湿报警' : item.humidityAlarm == 1 ? '高湿报警' : item.humidityAlarm == 2 ? '正常' : item.humidityAlarm) || '--' }}</p>
                    </div>
                    <div>
                        <p class="params-t">安装位置</p>
                        <el-tooltip effect="light" :content="item.installLocation" placement="right">
                          <p class='overText address-overtext'>{{item.installLocation || '--'}}</p>
                        </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="bottom-item">
                  <div class="silence">
                    <el-button type="primary" size="mini" round @click="handleSave('silence', item.deviceId, index)" :loading="isSilence_(index)">消音</el-button>
                    <!-- item.silence -->
                    <!-- <el-switch v-model="item.silence == 1" active-color="#178FFD" @change="handleSave('', item)"></el-switch> -->
                  </div>
                  <span>模组号: {{item.imei || '--'}}</span>
                </div>
              </li>
            </ul>
          </el-scrollbar>
          <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
            <img src="../../assets/img/noData.png" alt="">
            <div class="tip">暂无数据</div>
          </div>
          <div class="cardPage">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.currentPage"
              :page-sizes="pagination.pageSizes"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total">
            </el-pagination>
          </div>
        </div>
        <div class="maskingRight" v-if="changeStatus">
          <div class="listsRight" :class="showSlid?'component-slid-open' : 'component-slid-out'">
            <div class="messContainer">
              <div class="cons">
                <device-right-cons :typeId="19" @closeRightCons="closeRightCons"></device-right-cons>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mainContent" :style="styleObject" v-if="JSON.stringify(tabData) != '{}'">
    <div class="navShow">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <template v-if="JSON.stringify(tabData) != '{}'">
          <el-breadcrumb-item :to="{ path: '/deviceTH' }">
            <span @click="jumpDev">设备列表</span>
          </el-breadcrumb-item>
          <template>
            <el-breadcrumb-item>{{tabData.name}}</el-breadcrumb-item>
          </template>
        </template>
      </el-breadcrumb>
    </div>
    <div class="tabBox">
      <tab-block @tabToggle="toggleCom" :pageType="pageType" :tabs="tabs"></tab-block>
    </div>
    <div class="main">
      <component :is="component" :deviceId="deviceId" :deviceImei="deviceImei" type="tempHumidity"></component>
    </div>
  </div>

  <el-dialog title="设置" :visible.sync="dialogVisible" width="440px">
    <el-tabs v-model="activeName" @tab-click="handleTHClick">
      <el-tab-pane label="温度上限值" name="1" />
      <el-tab-pane label="湿度上限值" name="2" />
    </el-tabs>
    <ul class="edit-dialog">
      <!-- <li>
        <span class="title">名称</span>
        <el-input placeholder="请输入名称" v-model.trim="editData.name" clearable maxlength="10">
        </el-input>
      </li> -->
      <li v-show="activeName == 1">
        <span class="title">温度上限值</span>
        <el-input-number v-model="editData.temperatureUpperLimit" :min="-40" :max="100"></el-input-number>
        <span> ℃</span>
      </li>
      <li v-show="activeName == 1">
        <span class="title">温度下限值</span>
        <el-input-number v-model="editData.temperatureLowerLimit" :min="-40" :max="100"></el-input-number>
        <span> ℃</span>
      </li>
      <li v-show="activeName == 2">
        <span class="title">湿度上限值</span>
        <el-input-number v-model="editData.humidityUpperLimit" :min="1" :max="99"></el-input-number>
        <span> %RH</span>
      </li>
      <li v-show="activeName == 2">
        <span class="title">湿度下限值</span>
        <el-input-number v-model="editData.humidityLowerLimit" :min="1" :max="99"></el-input-number>
        <span> %RH</span>
      </li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave('save')">保 存</el-button>
    </span>
  </el-dialog>  
</div>
</template>

<script>
import TabBlock from '@/components/common/TabBlock'
import BasicInfo from '@/views/deviceManagement/deviceDetails/BasicInfo'
import DeviceDatas from '@/views/deviceManagement/deviceDetails/DeviceDatas'
import IssueCommand from '@/views/deviceManagement/deviceDetails/IssueCommand'
import AlarmRecord from '@/views/deviceManagement/deviceDetails/AlarmRecord'
import FaultRecord from '@/views/deviceManagement/deviceDetails/FaultRecord'
import InstallRecord from '@/views/deviceManagement/deviceDetails/InstallRecord'
import DeviceRightCons from '@/views/deviceManagement/gatewayChild/DeviceRightCons'
import Card from '@/components/common/Card'
import Echarts from '@/components/common/Echarts'
import { isEmptyValue } from '@/utils/validate'
export default {
  name:'DeviceGas',
  components: {
    TabBlock,
    BasicInfo,
    DeviceDatas,
    IssueCommand,
    AlarmRecord,
    FaultRecord,
    InstallRecord,
    Card,
    DeviceRightCons,
    Echarts
  },
  data() {
    return {
      activeName: '1',
      treeData: [],
      searchText: '',
      keyWords: {
        isAlarm: '',
        isFault: '',
        isInstall: '',
        isOnline: '',
        isRegist: '',
        typeId: ''
      },
      options: [
        { value: '1', label: '在线' },
        { value: '0', label: '离线' }
      ],
      component: '',
      tabs: [
        { name: '基本信息', code: 'BasicInfo' },
        { name: '设备数据', code: 'DeviceDatas' }, 
        // { name: '下发命令', code: 'IssueCommand' },
        { name: '报警记录', code: 'AlarmRecord' },
        { name: '故障记录', code: 'FaultRecord' },
        { name: '安装记录', code: 'InstallRecord' }
      ],
      pageType: 'DeviceGas',
      styleObject: {
        height: ''
      },
      styleObjectCons: {
        height: ''
      },
      tabData: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 12,
        pageSizes: [12, 22, 32],
        total: 0
      },
      dataList: [],
      deviceTypeList: [],
      fields:[],
      tableLoading: true,
      deviceId: null,
      getEchartStatus: '',
      deviceImei: '',
      changeStatus: false,
      consShow: false,
      currentTreeId: '',
      showSlid: false,
      isMobile: false, // 是否是终端设备
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
      dialogVisible: false,
      editData: {
        temperatureUpperLimit: 0,
        temperatureLowerLimit: 0,
        humidityUpperLimit: 0,
        humidityLowerLimit: 0
      },
      editId: null,
      chartOption: {
        series: [
          {
            type: 'gauge',
            radius: '70%',
            center: ['50%', '50%'],
            min: -50,
            max: 150,
            splitNumber: 5,
            startAngle: 210,
            endAngle: -30,
            progress: {
              show: false,
              roundCap: true,
              width: 9,
              itemStyle: {
                color: '#1890FF'
              }
            },
            pointer: {
              width: 3,
              length: '50%',
              itemStyle: {
                color: '#1890FF'
              }
            },
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 9,
                color: [[1, '#E6E6F2']]
              }
            },
            axisTick: {
              length: 3,
              distance: -16,
              splitNumber: 10,
              lineStyle: {
                color: '#1890FF',
              }
            },
            splitLine: {
              distance: -19,
              length: 6,
              lineStyle: {
                color: '#1890FF',
                width: 2
              }
            },
            axisLabel: {
              color: '#1890FF',
              distance: -15,
              fontSize: 10
            },
            detail: {
              valueAnimation: true,
              // formatter: '{value}℃',
              // color: '#1890FF',
              // fontSize: 14,
              formatter: function (value) {
                return '{value|' + value.toFixed(0) + '℃}\n{name|温度}';
              },
              rich: {
                value: {
                  fontSize: 14,
                  fontWeight: 'bolder',
                  color: '#1890FF',
                  lineHeight: 16,
                },
                name: {
                  fontSize: 12,
                  color: '#000',
                  lineHeight: 16,
                }
              },
              offsetCenter: [0, '-55%']
            },
            data: [
              { value: -50, name: '' }
            ]
          },
          {
            type: 'gauge',
            radius: '48%',
            center: ['50%', '80%'],
            min: 0,
            max: 100,
            splitNumber: 4,
            startAngle: 210,
            endAngle: -30,
            progress: {
              show: false,
              roundCap: true,
              width: 6,
              itemStyle: {
                color: '#16D585'
              }
            },
            pointer: {
              width: 2,
              length: '50%',
              itemStyle: {
                color: '#16D585'
              }
            },
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 6,
                color: [[1, '#E6E6F2']]
              }
            },
            axisTick: {
              length: 3,
              distance: -12,
              splitNumber: 10,
              lineStyle: {
                color: '#16D585',
              }
            },
            splitLine: {
              distance: -14,
              length: 4,
              lineStyle: {
                color: '#16D585',
                width: 2
              }
            },
            axisLabel: {
              color: '#16D585',
              distance: 20,
              fontSize: 9
            },
            detail: {
              valueAnimation: true,
              formatter: function (value) {
                // return '{value|' + value.toFixed(0) + '%}' + '\n' + '{name|湿度}';
                return '{value|' + value.toFixed(0) + '%}\n{name|湿度}';
              },
              rich: {
                value: {
                  fontSize: 14,
                  fontWeight: 'bolder',
                  color: '#16D585',
                  lineHeight: 16,
                },
                name: {
                  fontSize: 12,
                  color: '#000',
                  lineHeight: 16,
                }
              },
              offsetCenter: [0, '50%']
            },
            data: [{ value: 0, name: '' }]
          },
          // 温度上下限
          {
            type: 'gauge',
            radius: '70%',
            center: ['50%', '50%'],
            min: -40,
            max: 125,
            splitNumber: 1,
            startAngle: 198,
            endAngle: 0,
            progress: {
              show: false,
            },
            pointer: {
              width: 0,
            },
            axisLine: {
              roundCap: false
            },
            axisTick: {
              length: 0,
              distance: -16,
              splitNumber: 10,
              lineStyle: {
                color: 'red'
                // color: '#1890FF',
              }
            },
            splitLine: {
              distance: -19,
              length: 6,
              lineStyle: {
                color: 'red',
                // color: '#1890FF',
                width: 2
              }
            },
            axisLabel: {
              color: 'red',
              // color: '#1890FF',
              distance: -15,
              fontSize: 10
            },
            detail: {
              valueAnimation: true,
              formatter: function (value) {
                return ''
              },
              offsetCenter: [0, '-55%']
            },
            data: [
              { value: 0, name: '' }
            ]
          },
          {
            type: 'gauge',
            radius: '48%',
            center: ['50%', '80%'],
            min: 0,
            max: 100,
            splitNumber: 1,
            startAngle: 210,
            endAngle: -30,
            progress: {
              show: false,
            },
            pointer: {
              width: 0
            },
            axisLine: {
              roundCap: false
            },
            axisTick: {
              length: 0
            },
            splitLine: {
              distance: -14,
              length: 4,
              lineStyle: {
                color: 'red',
                width: 2
              }
            },
            axisLabel: {
              color: 'red',
              distance: 20,
              fontSize: 9
            },
            detail: {
              valueAnimation: true,
              formatter: function (value) {
                return ''
              },
              offsetCenter: [0, '50%']
            },
            data: [{ value: 0, name: '' }]
          }
        ]
      },
      isSilence_0: false,
    }
  },
  computed: {
    titleColor () {
      return ({ removal, alarmStatus }, i) => {
        // let temp = ['#C7C7C7', '#4CC790', '#EE211C']
        let color = removal == '0' ? '#C7C7C7' : alarmStatus  == 'On' ? '#EE211C' : '#4CC790'
        return color
      }
    },
    isSilence_ () {
      return i => {
        return this[`isSilence_${i}`]
      }
    }
  },
  created() {
    this.makeheight()
    this.makeheightCons()
    // this.queryTreeNode()
    // this.initData()
    this.getDeviceType()
  },
  methods: {
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // // 查询组织
    // queryTreeNode(pid = 0) {
    //   this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
    //     .then(rs => {
    //       // console.log(rs);
    //       this.treeData = rs.code === 200 ? rs.data : [];
    //       this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
    //     })
    //     .catch(error => (this.treeData = []));
    // },
    // 查询区域
    queryTreeNode(pid = 0) {
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          // console.log(rs);

          this.treeData = rs.code === 200 ? rs.data : [];
          // this.treeData.push({
          //   children: [],
          //   id: 'mobile',
          //   label: "终端出库设备",
          //   parentId: 0,
          //   serial: 51,
          //   tenantId: null,
          //   terminalFlag: null,
          //   value: 0
          // })
          this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:0):0;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.initData()
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          this.initData()
          resolve(data)
          
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
          // resolve([])
        })        
      }
    },    
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.isMobile = item.id == 'mobile'
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
    },
    getDeviceType() {
      this.request.post('/front/device/type/query', {
        page: 1,
        pageSize: 1000
      }).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.deviceTypeList = res.data.data?res.data.data:[]
        } else if (res.code === 500) {
          this.deviceTypeList = []
          this.msg.warn(res.msg)
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    serachData() {
      //查询//搜索
      this.getEchartStatus = this.keyWords.typeId
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1
      this.initData()
    },
    initData() {
      this.consShow = false
      this.params = {
        key: this.searchText,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orgId: this.currentTreeId?this.currentTreeId:0,
        typeId: this.keyWords.typeId,
        isInstall: this.keyWords.isInstall,
        isAlarm: this.keyWords.isAlarm,
        isFault: this.keyWords.isFault,
        isRegist: this.keyWords.isRegist,
        isOnline: this.keyWords.isOnline,
      }

      let url = this.params.orgId == -1 ? '/front/device/tempHumidity/queryOutbound' : '/front/device/tempHumidity/query'
      // let url = '/front/device/smoke/query'
      this.request.get(url, this.params)
        .then(res => {
          if (res.code === 200) {
            this.tableLoading = false
            this.consShow = true
            this.dataList = res.data || []
            this.pagination.total = res.total

          } else if (res.code === 500) {
            this.dataList = []
            this.msg.warn(res.msg)
          }
        })
        .then(res => {
          let dataList = [ ...this.dataList ]
          if (!dataList) return
          this.$nextTick(() => {
            dataList.forEach(({ currentTemperature, currentHumidity, temperatureUpperLimit, temperatureLowerLimit, humidityUpperLimit, humidityLowerLimit }, i) => {
              currentTemperature = currentTemperature || -50
              currentHumidity = currentHumidity || 0
              let myChart = this.$refs[`chart${i}`][0].chart
              let myOption = { ...myChart.getOption() }
              myOption.series[0].data[0].value = currentTemperature
              myOption.series[1].data[0].value = currentHumidity

              // 温度上下限
              myOption.series[2].min = temperatureLowerLimit
              myOption.series[2].max = temperatureUpperLimit
              myOption.series[2].startAngle = (125 - temperatureLowerLimit) * 1.2
              myOption.series[2].endAngle = (125 - temperatureUpperLimit) * 1.2

              // 湿度上下限
              myOption.series[3].min = humidityLowerLimit
              myOption.series[3].max = humidityUpperLimit
              myOption.series[3].startAngle = (87.5 - humidityLowerLimit) * 2.4
              myOption.series[3].endAngle = (87.5 - humidityUpperLimit) * 2.4

              // 当前温度不在范围内
              let isTempLowerRed = temperatureLowerLimit != null && temperatureLowerLimit != '' && (currentTemperature * 1 < temperatureLowerLimit * 1)
              let isTempUpperRed = temperatureUpperLimit != null && temperatureUpperLimit != '' && (currentTemperature * 1 > temperatureUpperLimit * 1)
              if (isTempLowerRed || isTempUpperRed) {       
                myOption.series[0].progress.itemStyle.color = 'red'
                myOption.series[0].detail.rich.value.color = 'red'
                myOption.series[0].pointer.itemStyle.color = 'red'
              } else {
                myOption.series[0].progress.itemStyle.color = '#1890FF'
                myOption.series[0].detail.rich.value.color = '#1890FF'
                myOption.series[0].pointer.itemStyle.color = '#1890FF'
              }

              // 当前湿度不在范围内 
              let isHumLowerRed = humidityLowerLimit != null && humidityLowerLimit != '' && (currentHumidity * 1 < humidityLowerLimit * 1)
              let isHumUpperRed = humidityUpperLimit != null && humidityUpperLimit != '' && (currentHumidity * 1 > humidityUpperLimit * 1)       
              if (isHumLowerRed || isHumUpperRed) {
                myOption.series[1].progress.itemStyle.color = 'red'
                myOption.series[1].detail.rich.value.color = 'red'
                myOption.series[1].pointer.itemStyle.color = 'red'
              } else {
                myOption.series[1].progress.itemStyle.color = '#1890FF'
                myOption.series[1].detail.rich.value.color = '#1890FF'
                myOption.series[1].pointer.itemStyle.color = '#1890FF'
              }

              myOption.series[0].progress.show = currentTemperature == -50 ? false : true
              myOption.series[1].progress.show = currentHumidity == 0 ? false : true
              myChart.setOption(myOption)
            })
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    jumpDev() {
      this.tabData = {}
      this.initData()
    },
    toggleCom(tabCode) {
      console.log(tabCode);
      this.tabData = tabCode
      this.component = tabCode.code
    },
    clickEven(val) {
      this.tabData = {
        name: '基本信息',
        code: 'BasicInfo'
      }
      this.deviceId = val.deviceId
      this.deviceImei = val.imei
    },
    /**
     * @Description 
     * @Author      YOYO     -             2021-10-21
     */
    handleClickSet (item) {
      // if (item.isOnline == '离线') return this.$message({ type: 'warning', message: '离线状态下不允许操作设备' })
      let { deviceId, temperatureUpperLimit, temperatureLowerLimit, humidityUpperLimit, humidityLowerLimit } = item

      this.dialogVisible = true
      this.editData = {
        id: deviceId,
        temperatureUpperLimit,
        temperatureLowerLimit,
        humidityUpperLimit,
        humidityLowerLimit
      }
    },
    /**
     * @Description 切换布防or撤防
     * @Author      YOYO     -             2021-10-21
     */
    handleSet (type, index, { deviceId, isOnline }) {
      // console.log(type, index)
      if (isOnline == '离线') return this.$message({ type: 'warning', message: '离线状态下不允许操作设备' })

      let temp = [
        { text: '撤防', color: '#EE211C', left: '0px', removal: '0' },
        { text: '布防', color: '#4CC790', left: '48px', removal: '1' }
      ]
      // let dom = this.$refs[`active${index}`]

      this.request.get('/front/device/fallRadar/removal', { deviceId, removal: type }).then(res => {

        if (res.code == 200) {
          // dom[0].style = `left: ${temp[type].left};background: ${temp[type].color}`
          // this.dataList[index].removal = temp[type].removal
          this.initData()
          this.$message({ type: 'success', message: '操作成功！' })
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      })
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    makeheightCons(height = 205) {
      let _this = this;
      _this.styleObjectCons.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObjectCons.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.initData()
    },
    handleSizeChange(val) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = val
      this.initData()
    },
    changeRightCons () {
      if (!this.changeStatus) {
        this.changeStatus = true
        this.showSlid = true
      } else {
        this.showSlid = false
        setTimeout(() => {
          this.changeStatus = this.showSlid
        },440)
      }
    },
    closeRightCons (data) {
      this.showSlid = false
      setTimeout(() => {
        this.changeStatus = data
      }, 440)
    },
    handleTHClick (e) {
      console.log(e.name)
    },
    /**
     * @Description 设置保存
     * @Author      YOYO     -             2021-11-27
     */
    handleSave (e, Sid, index) {
      let value = ''
      let idTemp = Sid
      let type = e === 'save' ? '4|5|6|7' : '13'

      if (e === 'save') {
        let { activeName } = this
        let { temperatureUpperLimit, temperatureLowerLimit, humidityUpperLimit, humidityLowerLimit, id } = this.editData

        // console.log(111, temperatureUpperLimit, temperatureLowerLimit)
        // console.log(123, isEmptyValue(temperatureLowerLimit))
        idTemp = id
        if (activeName == '1') {
          if (isEmptyValue(temperatureUpperLimit) || isEmptyValue(temperatureLowerLimit)) {
            return this.$message({ type: 'warning', message: '请将温度上/下限值填写完整！' })
          } else if (temperatureUpperLimit <= temperatureLowerLimit) {
            return this.$message({ type: 'warning', message: '温度上限值不能低于下限值' })
          }
          value = `${temperatureUpperLimit}|${temperatureLowerLimit}`
          type = '4|5'
        } else {
          if (isEmptyValue(humidityUpperLimit) || isEmptyValue(humidityLowerLimit)) {
            return this.$message({ type: 'warning', message: '请将湿度上/下限值填写完整！' })
          } else if (humidityUpperLimit <= humidityLowerLimit) {
            return this.$message({ type: 'warning', message: '湿度上限值不能低于下限值' })
          }
          value = `${humidityUpperLimit}|${humidityLowerLimit}`
          type = '6|7'
        }
        // if (temperatureUpperLimit == '' || temperatureLowerLimit == '' || humidityUpperLimit == '' || humidityLowerLimit == '') {
        //   return this.$message({ type: 'warning', message: '请填写完整！' })
        // } else if (temperatureUpperLimit <= temperatureLowerLimit) {
        //   return this.$message({ type: 'warning', message: '温度上限值不能低于下限值' })
        // } else if (humidityUpperLimit <= humidityLowerLimit) {
        //   return this.$message({ type: 'warning', message: '湿度上限值不能低于下限值' })
        // }

        // value = `${temperatureUpperLimit}|${temperatureLowerLimit}|${humidityUpperLimit}|${humidityLowerLimit}`
      } else {
        this[`isSilence_${index}`] = true
        value = '1'
        type = '13'
      }

      // let type = e === 'save' ? '4|5|6|7' : '13'

      this.request.get('/front/device/tempHumidity/command', {
        id: idTemp, type, value
      }).then(res => {
        if (e === 'silence') this[`isSilence_${index}`] = false
        if (res.code == 200) {
          // this.dialogVisible = false
          this.initData()
          this.$message({ type: 'success', message: res.msg })
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      }).catch(e => {
        this.$message({ type: 'error', message: e })
      })
    },    
  }
};
</script>

<style lang="scss" scoped>
.DeviceListsGas {
  position: relative;
  .devcieContainer{
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    h4 {
      padding-bottom: 10px;
    }
    .container {
      padding-left: 260px;
    }
    .query {
      padding-bottom: 10px;
      .queryCons{
        width: 100%;
        overflow: hidden;
        .common{
          float: left;
          margin-bottom: 5px;
        }
        .primaryBtn{
          width: 82px;
          height: 36px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 36px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;
          &:hover {
            background: #0774e0;
          }
        }
        .delSome{
          // width: 102px;
          // cursor: pointer;
          float: right;
          // font-size: 0;
          // padding: 0 10px;
          // border: 0;
          // color: #FFFFFF;
          // background: #1089FF;
          // border-radius: 2px;
          // outline: unset;
          // overflow: hidden;
          // &:hover{
          //   background: #0774e0;
          // }
          // .imgShow{
          //   float: left;
          //   width: 16px;
          //   height: 16px;
          //   margin:10px 6px 0 0;
          //   img{
          //     width: 100%;
          //     height: 100%;
          //     vertical-align: middle;
          //   }
          //   &.active{
          //     transform: rotate(180deg);
          //   }
          // }
          // span{
          //   float: left;
          //   font-size: 14px;
          //   line-height: 36px;
          // }
        }
      }
    }
    .listsContainer {
      overflow: hidden;
      position: relative;
      .listsLeft {
        float: left;
        width: 100%;
        height: 100%;
        box-sizing:border-box;
        padding: 0 0 60px;
        position: relative;
        background: #f2f2f2;
        .noData{
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;
          img{
            width: 300px;
            height: 300px;
          }
          .tip{
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }
        .device-cardList {
          height: 100%;
          width: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          font-size: 14px;
          .device-card {
            position: relative;
            display: inline-block;
            border: 1px solid #E1E1E1;
            background: #fff;
            width: 380px;
            // min-width: 240px;
            height: 280px;
            padding: 5px 10px;
            margin-top: 10px;
            margin-left: 20px;
            h6 {
              height: 28px;
              line-height: 28px;
              border-bottom: 1px solid #E1E1E1;
              overflow: hidden;
              .title {
                font-size: 18px;
                color: #000;
                display: inline-block;
                width: 60%;
              }
              .title-right {
                font-size: 12px;
                float: right;
                color: #178FFD;
                >span {
                  vertical-align: top;

                }
                .electric {
                  position: relative;
                  top: -2px;
                  display: inline-block;
                  width: 20px;
                  margin-left: 4px;
                  i {
                    position: absolute;
                    top: 11px;
                    left: 1px;
                    // border: 1px solid blue;
                    height: 10px;
                    background-color: #178FFD;
                    &.red {
                      background-color: #F24F4B;
                    }
                  }
                }
                .set {
                  margin-left: 4px;
                  font-size: 20px;
                  cursor: pointer;
                }
              }
            }
            .chart-item {
              // overflow: hidden;
              height: 215px;
              .chart {
                position: relative;
                display: inline-block;
                width: 248px;
                height: 100%;
                vertical-align: top;
                text-align: center;
                .top-title-box {
                  width: 100%;
                  margin: 20px 0 10px;
                  .top-title {
                    display: inline-block;
                    color: #fff;
                    font-size: 13px;
                    background: #C7C7C7;
                    width: 65px;
                    height: 25px;
                    text-align: center;
                    line-height: 25px;
                    border-radius: 4px;
                    margin: 0 3px;
                    &.gray {
                      background: #C7C7C7;
                    }
                    &.red {
                      background: #EE211C;
                    }
                    &.green {
                      background: #4CC790;
                    }
                    img {
                      height: 16px;
                      vertical-align: middle;
                      margin-right: 5px;
                    }
                  }            
                }
                >img {
                  width: 104px;
                }
                .state {
                  margin: 5px auto;
                  font-size: 13px;
                }
                .switch-box {
                  position: absolute;
                  bottom: 6px;
                  left: 70px;
                  border-radius: 25px;
                  overflow: hidden;
                  line-height: 20px;
                  font-size: 12px;
                  background: #F3F3F3;
                  color: #bbb;
                  .set {
                    cursor: pointer;

                  }
                  span {
                    display: inline-block;
                    width: 50px;
                    text-align: center;
                  }
                  .active {
                    width: 52px;
                    border-radius: 25px;
                    position: absolute;
                    top: 0px;
                    left:0px;
                    color: #fff;
                    background: #EE211C;
                    transition: 0.3s;
                  }
                }
              }
              .device-params {
                display: inline-block;
                width: 130px;
                margin-top: 16px;
                >div {
                  margin-bottom: 7px;
                  color: #333;
                  font-size: 12px;
                  .params-t {
                    display: inline-block;
                    color: #178FFD;
                    border: 1px solid #178FFD;
                    padding: 0px 12px;
                    line-height: 22px;
                    font-size: 13px;
                    font-weight: bold;
                    margin-bottom: 3px;
                  }
                  .address-overtext {
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }
                  // .time-t {
                  //   font-size: 10px;
                  // }
                }
              }
            }
            .bottom-item {
              position: absolute;
              bottom: 0px;
              width: calc(100% - 20px);
              border-top: 1px solid #E1E1E1;
              line-height: 34px;
              text-align: right;
              color: #B4B4B4;
              font-size: 12px;
              .silence {
                position: absolute;
                top: 0px;
                left: 0px;
                color: #178FFD;
              }
            }
            &.noOpen {
              h6 {
                // .title {
                //   color: #aaa;
                // }
                .title-right {
                  color: #aaa;
                  .electric i{
                    background-color: #aaa;
                  }
                }
                .set {
                  color: #178FFD
                }
              }
              .chart {
              }
              .device-params {
                >div {
                  color: #aaa;
                  .params-t {
                    color: #aaa;
                    border: 1px solid #aaa;
                  }
                }                
              }
            }
            &.outItem {
              h6 {
                // .title {
                //   color: #aaa;
                // }
                .title-right {
                  color: #aaa;
                  .electric i{
                    background-color: #aaa;
                  }
                }
              }
              .chart {
                .switch-box {
                  .set {
                    cursor: default;
                  }
                  .active {
                    background-color: #aaa!important;
                  }
                }
              }
              .device-params {
                >div {
                  color: #aaa;
                  .params-t {
                    color: #aaa;
                    border: 1px solid #aaa;
                  }
                }                
              }
            }
          }
        }
        // .cardList{
        //   height: 100%;
        //   width: 100%;
        //   // overflow-x: hidden;
        //   // overflow-y: auto;
        //   &>li{
        //     float: left;
        //     width: 300px;
        //     height: 240px;
        //     padding: 10px;
        //     box-sizing: border-box;
        //   }
        // }
        // .cardPage {
        //   position: absolute;
        //   bottom: 0;
        //   left: 0;
        //   width: 100%;
        //   height: 50px;
        //   text-align: center;
        //   padding: 10px 0;
        //   box-sizing: border-box;
        // }
        &.active{
          width: 100%;
          .cardList{
            height: 100%;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            &>li{
              float: left;
              width: 20%;
              height: 240px;
            }
          }
        }
      }
    }
  }
  .maskingRight{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .listsRight {
      position: absolute;
      right: 12px;
      top: 0;
      width: 740px;
      height: 100%;
      z-index: 9999;
      box-shadow: -2px 0 10px #ccc;
      background: #fff;

      &.component-slid-open {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        opacity: 1;
        animation: slid-open 0.5s ease;
      }

      &.component-slid-out {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        animation: slid-out 0.5s ease;
      }

      .messContainer {
        width: 100%;
        height: 100%;
        // padding-left: 10px;
        box-sizing: border-box;

        .cons {
          width: 100%;
          height: 100%;
          // background: #f3f3f3;
          // background: rgba(243,243,243,1);
        }
      }
    }
  }
  .mainContent{
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    .navShow {
      overflow: hidden;
      margin-bottom: 10px;
      border-bottom: 1px solid #f2f2f2;
    }
  }
  .edit-dialog {
    li {
      margin-top: 20px;
      .title {
        font-size: 14px;
        color: #333;
        display: inline-block;
        width: 80px;
      }
      .el-input {
        width: 300px;
        line-height: 40px;
        height: 40px;
      }
      .el-select {
        width: 300px;
      }
    }
  }  
  @keyframes slid-open{
      0%{
          transform: translateX(100%);
          opacity: 0;
      }
      100%{
          transform: translateX(0);
      }
  }
  @keyframes slid-out{
      0%{
          width: 600px;
          transform: translateX(0)
      }
      100%{
          transform: translateX(100%)
      }
  }
}
</style><style lang="scss">
.DeviceListsGas {
  .devcieContainer{
    .query {
      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 110px;
        margin-right: 10px;

        .el-input {
          width: 110px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }
    }
    .el-loading-mask{
      background-color: unset;
    }
    .treeAside {
      position: absolute;
      width: 300px;
      height: 100%;
      padding: 15px 20px;
      left: 0;
      top: 0;
      box-sizing: border-box;

      .treeTop {
        position: absolute;
        height: 40px;
        line-height: 40px;
        font-size: 0;
        font-weight: bold;
        top: 20px;
        z-index: 10;
        // left: 30px;
        padding-left: 10px;

        .treeTopTitle {
          margin-right: 115px;
          // width: 500px;
          font-size: 18px;
          color: #333;
        }

        .el-button {
          margin-left: -24px;
        }

        .complete {
          margin-left: 10px;
        }
      }

      .treeBox {
        overflow: hidden;
        height: 100%;
        border: 1px solid #ebeef5;
        padding: 40px 0 10px;
        box-sizing: border-box;
      }

      .tree {
        height: 100%;
        overflow: auto;

        .el-tree-node__content {
          height: 40px;
        }

        .custom-tree-node {
          height: 40px;
          line-height: 40px;
          width: 100%;

          .treeLabel {
            font-size: 14px;
            display: inline-block;
            width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .treeBtn {
            float: right;

            .el-button {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  .mainContent{
    .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
      color: #7A7D81;
      font-size: 16px;
      font-weight: 500;
    }
    .el-breadcrumb__separator{
      font-size: 16px;
      color: #7A7D81;
      margin: 0 5px;
      font-weight: 500;
    }
    .el-breadcrumb__inner{
      font-size: 16px;
      color: #7A7D81 !important;
      font-weight: 500 !important;
    }
  }
  .el-dialog__header {
    background-color: #1E2639;
    padding: 0;
    .el-dialog__title {
      font-size: 14px;
      color: #fff;
      line-height: 40px;
      margin-left: 22px;
    }
    .el-dialog__headerbtn {
      top: 13px;
      .el-dialog__close {
        color: #fff;
      }
    }
  }
  .edit-dialog {
    li {
      .el-input .el-input__inner{
        line-height: 40px;
        height: 40px;
      }
    }
  } 
}
</style>
